import "./button-component-styles.scss";

const ButtonComponent = ({
	newTab = "true",
	downloadBtn = "false",
	text,
	type,
	icon,
	btnLink,
}) => {
	return (
		<div className="button-box">
			{downloadBtn === "true" ? (
				<a
					href={btnLink}
					download={downloadBtn === "true" && "Moazam Ali Resume.pdf"}
					target={newTab === "true" ? `_blank` : `_self`}
					className={`button ${
						type === "large" ? " full-width" : ""
					}`}
				>
					{text} {icon}
				</a>
			) : (
				<a
					href={btnLink}
					target={newTab === "true" ? `_blank` : `_self`}
					className={`button ${
						type === "large" ? " full-width" : ""
					}`}
				>
					{text} {icon}
				</a>
			)}
		</div>
	);
};

export default ButtonComponent;
